exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n} \r\n\r\n.ui-autocomplete-multiple-container {\r\n\twidth: 100%;\r\n}\r\n\r\n.srm-sort-link {\r\n\tcolor: #449d44;\r\n\ttext-decoration: none;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.blocking {\r\n\tcolor: #a94442;\r\n\tbackground-color:  #f2dede;\r\n\tfont-weight: normal;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/user-anomalies/user-anomalies.component.css
// module id = 362
// module chunks = 0